import React, { useState, Fragment } from "react";
import { DropDown } from './DropDownRules'
import { Viz } from './AutomataViz'
import ruleSet from './rule-set.json'

import 'bulma/css/bulma.css'

// generative cellular automata
// discrete time-space 1d elemenatary systems

// https://www.cs.tau.ac.il/~nachumd/models/CA.pdf

// Elementary cellular automata a cell whose neighbors are all quiescent becomes quiescent. 
// small neighborhoods
// synchronous
const title = 'Elementary cellular automata'
const subtitle = '1d discrete space-time diagrams'
const href1 = "https://en.wikipedia.org/wiki/Dynamical_system"
const href2 = "https://en.wikipedia.org/wiki/Rule_30"
const href3 = "https://en.wikipedia.org/wiki/Rule_184"
const summary = <Fragment>                 
                  <p>Elementary cellular automata (ECA) are <a href={href1}>dynamical models</a> that 
                    generate large-scale patterns from small-scale local neighborhood processes. They 
                    are of particular interest because the simple boolean rules that govern their 
                    behaviors give rise to rich emergent properties as they propagate through space-time. 
                    ECA has been used to study nonlinear complex systems such as <a href={href2}>shell 
                    growth</a> in animals, <a href={href3}>traffic flow kinetics</a>, and many other 
                    phenomena.
                  </p>
              </Fragment>

const aside = <Fragment>
                <p className="is-size-7">
                  Space-time diagrams are seeded with stochastic inputs and rendered as 
                  connected graphs were vertices terminating along discontigious paths 
                  with only one parent are highlighted (<NodeIcon/>) for asethetics. 
                  Select different ECA rules from the dropdown menu.
                </p>
              </Fragment>

function NodeIcon() {
  return (
    <span style={{marginLeft: '0.1em', marginRight: '0.1em'}}>
      <svg alignmentBaseline="mathematical" 
        width="10" 
        height="10" 
        viewBox="0 0 12 12">
        <circle cx="6"
                cy="7"
                r="5"
                fill="#363636"
        >
        </circle>
      </svg>
    </span>
  )
}

function copyright(startYear) {
  const year = new Date().getFullYear()
  const yearStr = year - startYear === 0 
    ? ` © ${startYear}`
    : ` © ${startYear}–${year}`
  return ( <Fragment>
           <a href="https://www.seth-brown.net">Seth Brown</a>
           {yearStr}
         </Fragment> )
}

function App() {  

  const ruleNames = Object.keys(ruleSet)
  const [ruleName, setRuleName] = useState("90")

  function onChangeDropDown(e) {
    setRuleName(e.value)
  }

  const ruleObj = ruleSet[ruleName]
  const rules = new Map(Object.entries(ruleObj.rules))

  return (
    <section className="section">
      <div className="container">

        <div className="columns is-centered is-desktop">
          <div className="column is-three-fifths-desktop">
            <div className="title">
              <a href="https://en.wikipedia.org/wiki/Cellular_automaton">{title}</a>
            </div>
            <div className="subtitle">{subtitle}</div>            
             {summary}
          </div>
        </div>

        <div className="columns is-desktop">
          <div className="column is-one-third-touch">
            <DropDown
              onChangeDropDown={onChangeDropDown} 
              value={ruleName} 
              values={ruleNames}/>
          </div>
          <div className="column is-three-fifths-desktop">
            <Viz ruleName={ruleName} rule={rules}/>
          </div>
          <div className="column">
            {aside}             
          </div>
        </div>

        <div className="columns is-centered">
          <div className="column is-4 has-text-centered">
            {copyright(2019)}
          </div>
        </div>

      </div>
    </section>
  );
}

export default App;
